import graphqlClient from '~/graphql/graphqlClient';

export type CreateInnBattleResult = {
  battle_id: string;
};

export type MutationCreateInnBattleArgs = {
  playerId: string;
  gameSubmode: string;
  attackLoadout: unknown;
  opponentId: string;
  opponentRank: number;
};

const mutation = `
mutation CreateInnBattle($playerId: String!, $gameSubmode: String!, $attackLoadout: JSON!, $opponentId: String!, $opponentRank: Int!) {
  createInnBattle(playerId: $playerId, gameSubmode: $gameSubmode, attackLoadout: $attackLoadout, opponentId: $opponentId, opponentRank: $opponentRank) {
    battle_id
  }
}
`;

export default async function mutationCreateInnBattle(
  args: MutationCreateInnBattleArgs
): Promise<CreateInnBattleResult> {
  return await graphqlClient.request<CreateInnBattleResult>(
    'createInnBattle',
    mutation,
    args
  );
}
